import { render, staticRenderFns } from "./CnaeSelector.vue?vue&type=template&id=e99e16e2&scoped=true"
import script from "./CnaeSelector.vue?vue&type=script&lang=js"
export * from "./CnaeSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e99e16e2",
  null
  
)

export default component.exports